<template>
  <section class="all_emp card_style">
    <div class="d-flex align-items-center mb-2 gap-3">
      <AddFavDailog v-tooltip.left="$t('add to favorites')" />
      <h4>
        {{ $t("all_banners") }}
      </h4>
    </div>
    <div class="main_header_style mb-2">
      <div class="w-100 d-flex justify-content-between align-items-center">
        <div class="search-visa w-100">
          <form>
            <i class="fa-solid fa-magnifying-glass"></i>
            <input
              type="text"
              class="form-control w-50"
              :placeholder="$t('search...')"
              v-model="banner_search"
              @keyup="fetchAllBanners((page = 1))"
            />
          </form>
        </div>
        <router-link
          :to="`/banner/${
            $route.params.type == 'hotels'
              ? 'hotels'
              : $route.params.type == 'flight'
              ? 'flight'
              : $route.params.type == 'package'
              ? 'package'
              : ''
          }`"
          class="PrimaryButton mt-0 btn w-25"
          ><i class="fa-solid fa-plus"></i> {{ $t("add_banner") }}
        </router-link>
      </div>
    </div>

    <div class="row">
      <div class="table-responsive">
        <table class="table visaType" id="VisaTable">
          <thead>
            <tr>
              <th>ID</th>
              <th>{{ $t("photo") }}</th>
              <th>{{ $t("link") }}</th>
              <th>{{ $t("type") }}</th>
              <th>{{ $t("Control") }}</th>
            </tr>
          </thead>

          <tbody v-if="loading" class="text-center">
            <tr v-for="banner in 10" :key="banner">
              <td>
                <Skeleton height="2rem" width="90%" class="mb-2"></Skeleton>
              </td>
              <td width="10%">
                <Skeleton shape="circle" size="5rem"></Skeleton>
              </td>
              <td v-for="banner in 3" :key="banner">
                <Skeleton height="2rem" width="90%" class="mb-2"></Skeleton>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr v-for="(banner, index) in allBanners.data" :key="index">
              <td>{{ banner.id }}</td>
              <td><img :src="banner.image" alt="banner_image" /></td>
              <td>
                <a :href="banner.link" target="_blank">{{ banner.link }}</a>
              </td>
              <td>
                {{
                  banner.type == 1
                    ? $t("package")
                    : banner.type == 2
                    ? $t("flight")
                    : banner.type == 3
                    ? "hotel"
                    : ""
                }}
              </td>
              <td>
                <router-link
                  :to="`/banner/${banner.type}/${banner.id}`"
                  class="btn btn-success mx-1 w-auto"
                >
                  <i class="fa-regular fa-pen-to-square"></i>
                </router-link>

                <div
                  class="btn btn-danger mx-1 w-auto"
                  @click="deleteBanner(index)"
                >
                  <i class="fa-solid fa-trash"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <pagination
        :data="allBanners"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="fetchAllBanners"
      >
        <template v-slot:prev-nav>&lt;</template>
        <template v-slot:next-nav>&gt;</template>
      </pagination>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Swal from "sweetalert2";
import AddFavDailog from "@/components/layout/addFavDailog.vue";
import Skeleton from "primevue/skeleton";
export default {
  name: "allBanners",
  components: {
    pagination,
    AddFavDailog,
    Skeleton,
  },
  data() {
    return {
      allBanners: [],
      loading: true,
      banner_search: "",
    };
  },
  methods: {
    fetchAllBanners(page = 1) {
      const type = {
        type:
          this.$route.params.type == "hotels"
            ? 3
            : this.$route.params.type == "flight"
            ? 2
            : this.$route.params.type == "package"
            ? 1
            : "",
      };

      axios.post(`/index_banner?page=${page}`, type).then(({ data }) => {
        this.allBanners = data.data;
        this.loading = false;
      });
    },
    // delete banner
    deleteBanner(index) {
      Swal.fire({
        title: this.$t("check_delete"),
        text: this.$t("are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("back"),
        confirmButtonText: this.$t("confirm_delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          let delete_id = this.allBanners.data[index].id;
          const fromClick = true;
          axios.delete(`/delete_banner/${delete_id}`, { fromClick }).then(({ data }) => {
            if (data.status == true) {
              Swal.fire("", data.message, "success");
              this.allBanners.data.splice(index, 1); // Remove the deleted item from the array
            } else {
              Swal.fire("", data.message, "error");
            }
            return data;
          });
        }
      });
    },
  },
  mounted() {
    this.fetchAllBanners();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.main_header_style {
  align-items: center;
  h4 {
    margin-bottom: 0;
  }
}
.search-visa {
  form {
    position: relative;
    i {
      position: absolute;
      top: 12px;
      right: 15px;
      color: #9ca2ac;
    }
    input {
      padding-right: 40px !important;
    }
  }
}
</style>
